import React from "react";
import { useTranslation } from "react-i18next";
import RangeDatePicker from "common/components/DatePicker/RangePicker";
import SelectReusable from "components/Form/filterSelect/SelectReusable";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { useRole } from "hooks/useRole";
import { SelectObject } from "models/SelectObject";
import { filterName } from "pages/ReportsPage/types";
import { DecisionTypesCode, UserRole } from "../reportAssets/assets";

type selectedOption = {
  label: string;
  value: number;
};

type MultiFiltersProps = {
  rangeDatePicker: {
    initialStartDate: Date;
    initialEndDate: Date;
    onStartDateChange: (date: any) => void;
    onEndDateChange: (date: any) => void;
    defaultStartDate?: Date;
    defaultEndDate?: Date;
  };
  decisionSelect: {
    options: SelectObject[];
    onChange: (filterName: filterName, selectedOption: selectedOption) => void;
    selectedOption: selectedOption;
  };
  policeDecisionSelect: {
    options: SelectObject[];
    onChange: (filterName: filterName, selectedOption: selectedOption) => void;
    selectedOption: selectedOption;
  };
  policeRejectionReason: {
    options: SelectObject[];
    onChange: (filterName: filterName, selectedOption: selectedOption) => void;
    selectedOption: selectedOption;
  };
};

const MultiFilters = ({
  rangeDatePicker,
  decisionSelect,
  policeDecisionSelect,
  policeRejectionReason,
}: MultiFiltersProps) => {
  const { t } = useTranslation();
  const isFollowUp = useLocationForReportType() === "followup";
  const role = useRole();

  if (isFollowUp && role === UserRole.REGULAR) {
    return (
      <>
        <RangeDatePicker {...rangeDatePicker} />

        <SelectReusable
          {...decisionSelect}
          onChange={(value: { label: string; value: number }) =>
            decisionSelect.onChange(filterName.decisionId, value)
          }
          selectedOption={decisionSelect.selectedOption}
        />
      </>
    );
  }
  if (isFollowUp && role !== UserRole.REGULAR) {
    return (
      <>
        <SelectReusable
          {...decisionSelect}
          onChange={(value: { label: string; value: number }) =>
            decisionSelect.onChange(filterName.decisionId, value)
          }
          label={t("decision")}
          selectedOption={decisionSelect.selectedOption}
        />
        <SelectReusable
          {...policeDecisionSelect}
          onChange={(value: { label: string; value: number }) =>
            policeDecisionSelect.onChange(filterName.policeDecision, value)
          }
          label={t("labelPoliceDecisions")}
          selectedOption={policeDecisionSelect.selectedOption}
        />
        <SelectReusable
          {...policeRejectionReason}
          onChange={(value: { label: string; value: number }) =>
            policeRejectionReason.onChange(
              filterName.policeRejectionReason,
              value
            )
          }
          label={t("labelDisqualificationPoliceReasons")}
          selectedOption={policeRejectionReason.selectedOption}
        />
      </>
    );
  }
  if (role === UserRole.CONTROLCENTER) {
    const decisionsType = [
      DecisionTypesCode.InformationLetter,
      DecisionTypesCode.SevereInformationLetter,
      DecisionTypesCode.PackingForPolice,
    ];

    return (
      <SelectReusable
        onChange={(value: { label: string; value: number }) =>
          decisionSelect.onChange(filterName.decisionId, value)
        }
        options={decisionSelect.options.filter((option) =>
          [...decisionsType, 999].includes(option.value)
        )}
        label={t("decision")}
        selectedOption={decisionSelect.selectedOption}
      />
    );
  }
  return null;
};
export default MultiFilters;
